import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dd93ff5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "deprecation-banner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "banner-text" }, [
  /*#__PURE__*/_createTextVNode(" This portfolio is deprecated. Please visit my "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.linkedin.com/in/emmettmyers",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "linkedin-link"
  }, "LinkedIn"),
  /*#__PURE__*/_createTextVNode(" instead. ")
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}